import React, { useState } from 'react';

interface TwitchEmbedProps {
  channel: string;
  /**
   * Twitch requires `parent` to match the embedding page's hostname — a
   * mismatched value gets the iframe CSP-blocked (frame-ancestors). Defaults
   * to the live hostname so the embed works on localhost, the QA tunnel,
   * PTR, and prod without per-host wiring.
   */
  parent?: string;
  width?: string | number;
  height?: string | number;
}

export const TwitchEmbed: React.FC<TwitchEmbedProps> = ({
  channel,
  parent = window.location.hostname,
  width = '100%',
  height = '100%'
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const containerStyle: React.CSSProperties = {
    position: 'relative',
    width,
    height,
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: isHovered ? '0 0 20px rgba(145, 70, 255, 0.6)' : '0 4px 15px rgba(0, 0, 0, 0.5)',
    transition: 'all 0.3s ease',
    border: '2px solid rgba(145, 70, 255, 0.3)',
    background: '#000'
  };

  return (
    <div 
      style={containerStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <iframe
        src={`https://player.twitch.tv/?channel=${channel}&parent=${parent}&muted=true`}
        height="100%"
        width="100%"
        allowFullScreen
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
};
